<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group row">
              <!-- <label class="col-form-label col-2"><span translate="JEDINICAMERE.OZNAKA.SINGULAR"></span></label> -->
              <div class="col-md-12">
                <yt-input
                  [Type]="'text'"
                  name="txtOznaka"
                  formControlName="Oznaka"
                  #focusElement
                  [MaxLength]="200"
                  [ngClass]="{'is-invalid': submitted && fc.Oznaka.invalid}"
                  [Label]="'JEDINICAMERE.OZNAKA.SINGULAR'">
                </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.Oznaka.invalid">
                    <span *ngFor="let validation of errorMessages.Oznaka">
                      <span class="error-message" *ngIf="fc.Oznaka.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                    </span>
                    <!-- <span *ngIf="fc.Oznaka.errors.required">Oznaka je obavezan podatak</span> -->
                  </div>
              </div>
            </div>
          <div class="form-group row">
            <!-- <label class="col-form-label col-2"><span translate="JEDINICAMERE.NAZIV.SINGULAR"></span></label> -->
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtNaziv"
                formControlName="Naziv"
                [MaxLength]="200"
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'JEDINICAMERE.NAZIV.SINGULAR'"
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                  <span *ngFor="let validation of errorMessages.Naziv">
                    <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                  <!-- <span *ngIf="fc.Naziv.errors.required">Naziv je obavezan podatak</span> -->
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>